export default function usePrivacyPolicy() {
  const openLink = (e: MouseEvent, callback?: () => void) => {
    const targetElement = e.target
    const hrefValue = targetElement && 'href' in targetElement ? targetElement.href : ''

    if (!hrefValue) {
      callback && callback()
      return
    }

    navigateTo(hrefValue, {
      external: true,
      open: {
        target: '_blank'
      }
    })
  }

  return {
    openLink
  }
}
